import { render, staticRenderFns } from "./Estatus.vue?vue&type=template&id=9fd497b6&"
import script from "./Estatus.vue?vue&type=script&lang=js&"
export * from "./Estatus.vue?vue&type=script&lang=js&"
import style0 from "./Estatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports